import { Login } from "../features/login"
import MyPageLayout from "../layout/MyPage/MyPageLayout"
import type { GetStaticProps, NextPageWithLayout } from "../types/next"

const LoginPage: NextPageWithLayout = () => {
  return <Login />
}

export default LoginPage

LoginPage.getLayout = (page) => {
  return <MyPageLayout layout="simple">{page}</MyPageLayout>
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      seo: {
        canonical: "https://www.p-ban.com/kiban/csComLogin.do",
      },
    },
  }
}
